export default __webpack_public_path__ + "images/loggedout/home/modularPage/playsheets-85e638dc067e8c3de4fbcf3894c14c6d.png";